export default __webpack_public_path__ + "static/media/close.6d93ca22.svg";